import axiosSecure from '@api/axiosSecure';
import getContextRoot from '@api/getContextRoot';

const deleteLocation = async (locationId: number | string): Promise<any> => {
  const res = await axiosSecure.delete(`${getContextRoot()}/location/${locationId}`);
  return res.data;
};

export default deleteLocation;
